import { useParams, Navigate } from 'react-router-dom';

import { TriggeredMessageDetails } from './components/triggered-message-details';

import { routeCreator } from '../triggered-messages.utils';

export const TriggeredMessageView = () => {
  const { messageId, scope } = useParams<{ messageId?: string; scope?: string }>();

  if (!messageId) {
    return <Navigate to={routeCreator.base.to()} replace />;
  }

  return <TriggeredMessageDetails messageId={messageId} scope={scope} />;
};
